import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlogpageService } from '../blogpage.service';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { ArticleContentContainerComponent } from './article-content-container/article-content-container.component';
import { ReArticleComponent } from './re-article/re-article.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
  imports: [
    ArticleContentContainerComponent,
    ReArticleComponent,
    CommonGetstartedComponent,
  ],
})
export class ArticleComponent implements OnInit {
  getStartedData: any;
  pageData: any;
  constructor(
    private activeRoute: ActivatedRoute,
    private blogPageSerive: BlogpageService,
    private canonical: CanonicalService,
    private posthogService: PosthogService
  ) {}

  async ngOnInit(): Promise<void> {
    const articleId = this.activeRoute.snapshot?.params?.['id'];
    this.blogPageSerive.getArticleData(
      this.activeRoute.snapshot?.params?.['id']
    );
    this.canonical.setCanonicalURL();
    const d = await this.blogPageSerive.getAllBlogArticles();
    this.pageData = d.filter(
      (el: any) => el?.fields?.blogId.toLowerCase() === articleId
    )[0];
      const data = this.pageData;
      if (data) {
        let gettingStarted = data?.fields?.gettingStarted?.fields;
        if (gettingStarted) {
          this.getStartedData = {
            header: gettingStarted?.title,
            button1: {
              url: gettingStarted?.buttons?.[0]?.fields?.redirectLink || '',
              text: gettingStarted?.buttons?.[0]?.fields?.buttonText || '',
              target: gettingStarted?.buttons?.[0]?.fields?.actionType || '',
            },
            button2: {
              url: gettingStarted?.buttons?.[1]?.fields?.redirectLink || '',
              text: gettingStarted?.buttons?.[1]?.fields?.buttonText || '',
              target: gettingStarted?.buttons?.[1]?.fields?.actionType || '',
            },
          };
        }
      }
    this.posthogService.capturePageViewEvent(articleId);
  }
}
